import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import {
    MobileOptionsMenuService,
    OptionsMenuItem,
} from "@/_services/mobile-options-menu.service";

@Component({
    selector: "app-mobile-options-panel",
    standalone: true,
    imports: [CommonModule, SharedComponentsModule],
    templateUrl: "./mobile-options-panel.component.html",
    styleUrls: ["./mobile-options-panel.component.scss"],
})
export class MobileOptionsPanelComponent {
    readonly state$ = this.service.state$;

    constructor(private service: MobileOptionsMenuService) {}

    close(): void {
        this.service.close();
    }

    invoke(item: OptionsMenuItem): void {
        this.service.close();
        item.action();
    }
}
